import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import {withRouter} from "react-router-dom";
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import ResetPasswordModal from "../../../GlobalComponents/ResetPasswordModal";
import AboutUsModal from "../../../GlobalComponents/AboutUsModal";

class Topbar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isModal: false,
      isAboutUsModal: false,
      clientId: props.match.params.clientId
    };
  }
  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
  };

  onModalChange = () => {
    this.setState({
      isModal: !this.state.isModal
    })
  }

  onAboutModalChange = () => {
    this.setState({
      isAboutUsModal: !this.state.isAboutUsModal
    })
  }

  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility, isSideBar } = this.props;
    const { clientId, isModal, isAboutUsModal } = this.state;
    return (
      <div className="topbar">
        { isModal ? <ResetPasswordModal onClose={this.onModalChange} isSelf={true} /> : null }
        { isAboutUsModal ? <AboutUsModal onClose={this.onAboutModalChange} isSelf={true} /> : null }
        <div className="topbar__wrapper">
          <div className="topbar__left">
            {
              isSideBar && <TopbarSidebarButton
                changeMobileSidebarVisibility={changeMobileSidebarVisibility}
                changeSidebarVisibility={changeSidebarVisibility}
            />
            }

            <Link className="topbar__logo ml-35" to={`/${clientId}/certification`} />
          </div>
          <div className="topbar__right">
            <TopbarProfile
                onModalChange={this.onModalChange}
                onAboutModalChange={this.onAboutModalChange}
            />
          </div>
          
        </div>
      </div>
    );
  }
}

export default withRouter(Topbar);
